import {
    ACTIVATE_BUSINESSCATEGORY_FAILED,
    ACTIVATE_BUSINESSCATEGORY_LOADING,
    ACTIVATE_BUSINESSCATEGORY_SUCCESS,
   
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
businessCategory: null,
    status: null,
  };
  
  export const activateBusinessCategoryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
  ) => {
    switch (action.type) {
      case ACTIVATE_BUSINESSCATEGORY_LOADING:
        return {
          ...state,
          loading: action.loading,
        };
      case ACTIVATE_BUSINESSCATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          businessCategory: action.payload,
          status: action.status,
          error: null,
        };
      case ACTIVATE_BUSINESSCATEGORY_FAILED:
        return {
          ...state,
          loading: false,
          businessCategory: null,
          status: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  